import React from 'react'
import Util from './Util'
import Com from './Com.js'
import Atmospheres from './Atmospheres.js'
import yaml from 'yaml'
import Timer from './Timer.js'
import MagicData from './MagicData.js'
import md5 from './md5.js'

let sessionAmountMagicData = MagicData.newMagicData(0)
let sessionTimerConfMagicData = MagicData.newMagicData()
let sessionTimerPositionMagicData = MagicData.newMagicData()
let musicTimerConfMagicData = MagicData.newMagicData()
let musicTimerPositionMagicData = MagicData.newMagicData()
let currentLyricsMagicData = MagicData.newMagicData([])
let atmosphereIdMagicData = MagicData.newMagicData()
let filterMagicData = MagicData.newMagicData('sepia(0) brightness(1) contrast(1) saturate(1) hue-rotate(360deg)')
let activeGameMagicData = MagicData.newMagicData(null)
let softMagicData = MagicData.newMagicData(null)
let blurOnTvMagicData = MagicData.newMagicData(null)
let inverseKaraWorldTVAndVPMagicData = MagicData.newMagicData()
let hiddenClickCount = 0

let Songs = null
async function loadSongs() {
	await fetch("../songs/Songs.json")
	.then((response) => response.text())
	.then(function (text) {
		Songs = JSON.parse(text)
	})
}
await loadSongs()

let currentSongId = null
musicTimerConfMagicData.addChangeCb(async function(newConf) {
	if (!newConf) {
		currentSongId = null
		currentLyricsMagicData.setValue([])
	}
	else {
		let newSongId = newConf[4]
		if (newSongId === currentSongId) return
		currentSongId = newSongId
		let song = Songs[newSongId]
		let folder = md5(newSongId+'_folder')
		for (let idx=1; idx<=song.nbTracks; ++idx) {
			let lyricsFile = md5(newSongId+'_lyrics'+idx+'File')
			await fetch('../songs/'+folder+'/'+lyricsFile)
			.then(response => response.text())
			.then(function(text) {
				currentLyricsMagicData.setValue([...currentLyricsMagicData.getValue(), yaml.parse(text)])
			})
		}
	}
})

Timer.newTimer(sessionTimerConfMagicData, sessionTimerPositionMagicData)
Timer.newTimer(musicTimerConfMagicData, musicTimerPositionMagicData)

let initialized = false
function init() {
	initialized = true
	Com.connectMagicData(sessionAmountMagicData, '', 'sessionAmount')
	Com.connectMagicData(sessionTimerConfMagicData, '', 'sessionTimerConf')
	Com.connectMagicData(musicTimerConfMagicData, '', 'musicTimerConf')
	Com.connectMagicData(atmosphereIdMagicData, '', 'atmosphereId')
	Com.connectMagicData(filterMagicData, '', 'filter', true)
	Com.connectMagicData(activeGameMagicData, '', 'activeGame')
	Com.connectMagicData(softMagicData, '', 'soft')
	Com.connectMagicData(inverseKaraWorldTVAndVPMagicData, '', 'inverseKaraWorldTVAndVP')
	let windowLocationCb = function(newValue) {
		if (!softMagicData.getValue()) return
		if (softMagicData.getValue() === 'KaraWorld') return
		if (softMagicData.getValue() === 'v2' && !activeGameMagicData.getValue()) window.location.href = 'http://localhost:42520/quiz2/index.html?monitor='+(inverseKaraWorldTVAndVPMagicData.getValue()?'vp':'tv')
	}
	activeGameMagicData.addChangeCb(windowLocationCb)
	softMagicData.addChangeCb(windowLocationCb)
	Com.connectMagicData(blurOnTvMagicData, '', 'blurOnTv')
}

function TV() {

	if (!initialized) init()

	const [sessionAmount, setSessionAmount] = React.useState(sessionAmountMagicData.getValue())
	const [sessionTimerPosition, setSessionTimerPosition] = React.useState(sessionTimerPositionMagicData.getValue())
	const [musicTimerConf, setMusicTimerConf] = React.useState(musicTimerConfMagicData.getValue())
	const [musicTimerPosition, setMusicTimerPosition] = React.useState(musicTimerPositionMagicData.getValue())
	const [sessionTimerConf, setSessionTimerConf] = React.useState(sessionTimerConfMagicData.getValue())
	const [currentLyrics, setCurrentLyrics] = React.useState(currentLyricsMagicData.getValue())
	const [atmosphereId, setAtmosphereId] = React.useState(atmosphereIdMagicData.getValue())
	const [filter, setFilter] = React.useState(filterMagicData.getValue())
	const [blurOnTv, setBlurOnTv] = React.useState(blurOnTvMagicData.getValue())

	sessionAmountMagicData.addChangeCb(setSessionAmount)
	sessionTimerPositionMagicData.addChangeCb(setSessionTimerPosition)
	sessionTimerConfMagicData.addChangeCb(setSessionTimerConf)
	musicTimerPositionMagicData.addChangeCb(setMusicTimerPosition)
	musicTimerConfMagicData.addChangeCb(setMusicTimerConf)
	currentLyricsMagicData.addChangeCb(setCurrentLyrics)
	atmosphereIdMagicData.addChangeCb(setAtmosphereId)
	filterMagicData.addChangeCb(setFilter)
	blurOnTvMagicData.addChangeCb(setBlurOnTv)

	let currentSong = musicTimerConf ? Songs[musicTimerConf[4]] : null
	let atmosphere = Atmospheres[atmosphereId]
	let delayOpacity = 0.3
	let delayPre = 1
	let delayPost = 0
	let delayAudio = -0.2
	let t = musicTimerPosition-delayAudio
	let singers = currentSong ? currentLyrics.map((_, num) => currentSong['singer'+(num+1)]) : []
	let session = ''
	if (sessionAmount === 0) session = 'closed'
	else if (sessionTimerConf === null) session = 'waitForClick'
	else if (sessionAmount-sessionTimerPosition <= 0) session = 'lastSong'
	else session = 'opened'
	let nbTracks = currentSong ? currentSong.nbTracks : 0
	let lyricsSize = nbTracks > 2 ? 1.38 : 2.07
	let delayCredits = 5

	return (
		<div 
			style={{width: '1920px', height: '1080px', background: 'black', color: 'white', textAlign: 'center'}}
			onClick={function() {
				hiddenClickCount++
				if (hiddenClickCount >= 10) {
					Com.setVariable('', 'system', 'shutdown')
				}
			}}>
			{!atmosphere &&
				<div style={{position: 'absolute', left: '0px', top: '0px', width: '1920px', height: '1080px', background: 'black', overflow: 'hidden'}}></div>
			}
			{atmosphere && atmosphereId === 'welcome' &&
				<div
					style={{position: 'absolute', left: '420px', top: '380px', zIndex: '1000', pointerEvents: 'none', width: '1080px', height: '300px', background: 'no-repeat url(images/logo_client.png)'}}
				></div>
			}
			{atmosphere &&
				<div style={{position: 'absolute', left: '0px', top: '0px', width: '1920px', height: '1080px', background: 'black', overflow: 'hidden', filter: (atmosphere.id.startsWith('welcome') || !blurOnTv) ? null : 'blur(20px)'}}>
					<video key={atmosphere.id} width='1920px' height='1080px' autoPlay loop style={{filter: atmosphere.filter_tv||''}}>
						<source src={'../decors/'+atmosphere.decor_tv} type='video/mp4' />
					</video>
				</div>
			}
			{currentSong && t < delayCredits && ['writers', 'publishers'].map(function (k, num) {
				let fontSize = 30
				return (
					<div key={num} style={{position: 'absolute', left: 50, top: 900 +(num*60)+'px', marginLeft: 'auto', marginRight: 'auto', height: '50px', width: '1820px'}}>
						<div style={{background: 'black', color: '#909090', opacity: 1, display: 'inline-block', fontSize: fontSize+'px', padding: (0.4*fontSize)+'px'}}>
							{currentSong[k]}
						</div>
					</div>
				)
			})}
			{sessionAmount-sessionTimerPosition <= 5*60 && sessionAmount-sessionTimerPosition > 0 &&
				<div style={{position: 'absolute', left: '50px', top: '950px', marginLeft: 'auto', marginRight: 'auto', width: '1820px', opacity: 1, fontFamily: 'Open Sans Condensed Light', fontSize: '90px'}}>
					<div style={{background: 'black', color: 'white', display: 'inline-block', padding: '0px 20px 5px 20px'}}>
						{Util.formatDurationMSOrHMS(sessionAmount-sessionTimerPosition)}
					</div>
				</div>
			}
			{session === 'lastSong' &&
				<div style={{position: 'absolute', left: '50px', top: '950px', marginLeft: 'auto', marginRight: 'auto', width: '1820px', opacity: 1, fontFamily: 'Open Sans Condensed Light', fontSize: '90px'}}>
					<div style={{background: 'black', color: 'white', display: 'inline-block', padding: '0px 20px 5px 20px'}}>
						Dernière chanson !
					</div>
				</div>
			}
			<div style={{fontFamily: 'Adobe Caslon Pro Regular', fontSize: nbTracks === 1 ? '130px' : (32*lyricsSize)+'px'}}>
				{singers.map(function(num, k) {
					let topOffset = nbTracks === 2 ? 150 : 0;
					let leftSpacing = nbTracks === 1 ? 50 :
						(k === 2 && nbTracks === 3 ) ? 12+(1920-12-12-455*lyricsSize)/2 + 'px' : 
						(12+(1920-12-12-455*lyricsSize)*(k%2)) + 'px';
					return (
						<div key={k}>
							{ nbTracks > 1 && singers[k] !== '' &&
								<div key={0} style={{position: 'absolute', left: leftSpacing, top: (topOffset+250+(-2)*49*lyricsSize + Math.floor(k/2)*450)+'px', marginLeft: 'auto', marginRight: 'auto', width: (455*lyricsSize)+'px'}}>
									<div style={{background: 'black', color: '#909090', opacity: 1, display: 'inline-block', padding: (13*lyricsSize)+'px '+(5*lyricsSize+18)+'px '+(2*lyricsSize)+'px '+(5*lyricsSize+18)+'px'}}>
										{singers[k]}
									</div>
								</div>
							}
							{currentLyrics[k] && currentLyrics[k].map(function(line, i) {
								let opacity = 0
								let topSpacing = nbTracks === 1 ? (150+(i%4)*195)+'px' : (topOffset+250+((i%4)*49*lyricsSize))+Math.floor(k/2)*450+'px';
								let widthSpacing = nbTracks === 1 ? '1820px' : (455*lyricsSize)+'px';
								let paddingSpacing = nbTracks === 1 ? '40px 0px 5px 0px' : (13*lyricsSize)+'px 0px '+(2*lyricsSize)+'px 0px';
								let segmentPaddingSpacing = nbTracks === 1 ? '40px 20px 5px 20px' : (13*lyricsSize)+'px '+(5*lyricsSize)+'px '+(2*lyricsSize)+'px '+(5*lyricsSize)+'px';
								if (t >= line.start-delayPre && t <= line.end+delayPost) opacity = 1
								else if (t > line.start-delayPre-delayOpacity && t < line.start-delayPre) opacity = (t-(line.start-delayPre-delayOpacity))/delayOpacity
								else if (t > line.end+delayPost && t < line.end+delayPost+delayOpacity) opacity = 1-(t-(line.end+delayPost))/delayOpacity
								//if (opacity < 0.5) opacity = 0 // Si la vidéo rame à cause de la transparence
								//else if (opacity >= 0.5) opacity = 1 // Si la vidéo rame à cause de la transparence
								return (
									<div key={i+1} style={{position: 'absolute', zIndex: 1000, left: leftSpacing, top: topSpacing, marginLeft: 'auto', marginRight: 'auto', width: widthSpacing, opacity: opacity, scale: '0.9', whiteSpace: 'nowrap'}}>
										<div key={0} style={{background: 'black', color: 'black', display: 'inline-block'}}>
											<div style={{background: 'black', color: 'white', mixBlendMode: 'multiply', display: 'inline-block', outline: '1px solid black', padding: paddingSpacing}}>&nbsp;</div>
										</div>
										{line.segments.map(function(segment, j) {
											let progress = 0
											if (t >= segment.end) progress = 100
											else if (t > segment.start) progress = (t-segment.start)/(segment.end-segment.start)*100
											return (
												<div key={j+1} style={{background: 'linear-gradient(to right, #1d8dd6 '+progress+'%, white '+progress+'%)', display: 'inline-block'}}>
													<div style={{background: 'black', color: 'white', mixBlendMode: 'multiply', display: 'inline-block', outline: '1px solid black', padding: segmentPaddingSpacing}}>
														{segment.text}
													</div>
												</div>
											)
										})}
										<div key={line.segments.length+1} style={{background: 'black', color: 'black', display: 'inline-block'}}>
											<div style={{background: 'black', color: 'white', mixBlendMode: 'multiply', display: 'inline-block', outline: '1px solid black', padding: paddingSpacing}}>&nbsp;</div>
										</div>
									</div>
								)
							})}
						</div>
					)
				})}
			</div>
		</div>
	)
}

export default TV
